import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from './snitem';

@RegisterItem()
export class CNContactTypeManager extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNContactTypeManager';
    }

    public clone(): any {
        return new CNContactTypeManager();
    }
}
